// extracted by mini-css-extract-plugin
export default {"container":"Card_container__-Sx3Z","title":"Card_title__RYYan","cardTitle":"Card_cardTitle__oTU15","cardSubTitle":"Card_cardSubTitle__SDRBP"};